var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFourPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 14,
    rx: 4.5,
    stroke: "#BBBBBE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14273 12H10.174V10.248H11.3752V9.30469H10.174V3.54492H8.64469C7.46109 5.30859 6.16617 7.37109 5.02359 9.28711V10.248H9.14273V12ZM6.10172 9.24023C7.02164 7.6875 8.12906 5.94141 9.07828 4.52344H9.14859V9.31055H6.10172V9.24023ZM16.2459 9.14062H18.6014V8.19141H16.2459V5.71875H15.2967V8.19141H12.9413V9.14062H15.2967V11.6133H16.2459V9.14062Z",
    fill: "#BBBBBE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourPlus);
export default __webpack_public_path__ + "static/media/four-plus.b7cf86a1d1ca09875cf62cd6eb8eb00b.svg";
export { ForwardRef as ReactComponent };